const E="wix-draft-plugin-image",A="IMAGE";export{E as IMAGE_TYPE,A as IMAGE_TYPE_LEGACY};
//# sourceMappingURL=types.js.map
